module.exports = __webpack_public_path__ + "img/hospital.f03e2741.svg";